import { config } from 'ui/blocks';
import blockStyles from './blocks.scss';

export default function setupBlockStyles() {
    config.set({ styles: blockStyles });
}



/** WEBPACK FOOTER **
 ** ./src/hellosign/common/style/blocks.js
 **/